import VueRouter from "vue-router";

export class ZollServiceService {
  public isServicePage(router: VueRouter): boolean {
    return router.currentRoute.name === 'Service';
  }
}

export const zollServiceService = new ZollServiceService();